import { TextJustification } from "@faire/web-api--source/indigofair/data/TextJustification";

export const getCssTextJustification = (
  key?: keyof typeof TextJustification
) => {
  switch (key) {
    case TextJustification.START:
      return "flex-start";
    case TextJustification.CENTER:
      return "center";
    case TextJustification.END:
      return "flex-end";
    default:
      return "flex-start";
  }
};

export const getCssTextAlign = (key?: keyof typeof TextJustification) => {
  switch (key) {
    case TextJustification.START:
      return "start";
    case TextJustification.CENTER:
      return "center";
    case TextJustification.END:
      return "end";
    default:
      return "start";
  }
};
